import React from 'react';
import { View, Text } from 'react-native';
import DbIcon from '../../DbIcon';
import { styles } from './styles';
import type { DbChatMetaProps } from './types';

/** 格式化时间 */
const formatTime = (timestamp: number): string => {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
};

/** 状态图标配置 */
interface StatusIconConfig {
    icon: string;
    color: string;
}

const STATUS_ICON: Record<string, StatusIconConfig> = {
    sent: { icon: 'checkmark', color: '#C7C7CC' },
    read: { icon: 'checkmark-done', color: '#007AFF' },
};

const DbChatMeta: React.FC<DbChatMetaProps> = ({
    timestamp,
    status,
    direction,
    isRead = false,
    showTime = true,
    showStatus = true,
}) => {
    // 只在右侧消息且非失败状态时显示
    const shouldShowStatus = showStatus && direction === 'right' && status !== 'failed';

    // 已读状态优先
    const finalIcon = isRead ? STATUS_ICON.read.icon : STATUS_ICON.sent.icon;
    const finalColor = isRead ? STATUS_ICON.read.color : STATUS_ICON.sent.color;

    return (
        <View style={[styles.container, direction === 'right' ? styles.containerRight : styles.containerLeft]}>
            {/* 状态图标在前面 */}
            {shouldShowStatus && (
                <DbIcon
                    name={finalIcon}
                    family="Ionicons"
                    size={12}
                    color={finalColor}
                />
            )}
            {showTime && (
                <Text style={styles.time}>{formatTime(timestamp)}</Text>
            )}
        </View>
    );
};

DbChatMeta.displayName = 'DbChatMeta';

export default DbChatMeta;
export type { DbChatMetaProps } from './types';
